import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';

function CustomCarousel() {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };
    return (
        <Carousel id="carousal" activeIndex={index} onSelect={handleSelect}>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="Login_img_1.jpg"
                    alt="Second slide"
                />
                <Carousel.Caption>
                    <h5 className="text-left mb-0">Welcome to</h5>
                    <h2 className="text-left">Alaska Medicaid Member Portal</h2>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="Login_img_2.jpg"
                    alt="Third slide"
                />
                <Carousel.Caption>
                    <h5 className="text-left mb-0">Welcome to</h5>
                    <h2 className="text-left">Alaska Medicaid Member Portal</h2>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    );
}
export default CustomCarousel;